import React from 'react';

const Summary = () => {
    return (
      <React.Fragment>
        <div style={{ textAlign: 'justify' }}> 
            <p>
                Atuo na área de TI há quase duas décadas, com foco em análise e desenvolvimento de software. <br />
                Ao longo desse período, trabalhei em diversos projetos, abrangendo múltiplos segmentos e atuando com diversas tecnologias, 
                desde linguagens de programação clássicas até soluções modernas em nuvem e arquiteturas escaláveis.
            </p>        
            <p>
                Trabalhar com tecnologia significa enfrentar uma transformação diária. 
                A evolução é constante, e nós, profissionais, precisamos nos adaptar rapidamente. Para entregar um serviço de qualidade, 
                a colaboração e o trabalho em equipe são essenciais, assim como o domínio de aspectos técnicos, como código, infraestrutura e arquitetura de software, aliado a um sólido entendimento do negócio.
            </p>
            <p>
                Sobre ser um leitor de livros diversos acredito que a leitura seja fundamental pois nos ajuda a expandir nossos horizontes, 
                são meus power-ups favoritos que vou do "O Poder do Hábito" ao "O Guia do Mochileiro das Galáxias".
                <br />       
                E os games que viram metáforas da vida real, exemplo o jogo Dark Souls onde você perde 100x até aprender o padrão do chefe, 
                bem como debuggar código legado.
            </p>
         </div>
    </React.Fragment>
    )
}
export default Summary;